import {PearlHarbor} from "../../PearlHarbor";
import {TimelineLite, TweenLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {Sprite} from "pixi.js";
import {IFinalWave} from "../../server/PearlHarborData";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class BonusMeters extends PIXI.Container {

    private MG_COVER_POS:number[][] = [[96,165],[91,179],[101,179]];
    private BA_COVER_POS:number[][] = [[324,168],[318,175],[321,179],[326,180],[331,177],[331,173]];
    private _bonusMeters: PIXI.Sprite;
    private _spinsLeftCover: PIXI.Sprite;
    private _dogFightCovers: PIXI.Sprite[];
    private _bombAttackCovers: PIXI.Sprite[];
    private _baMeterBroken: PIXI.Sprite;
    private _bulletLeftCover: PIXI.Sprite;
    private _bombLeftCover: PIXI.Sprite;
    private _kamikazeCover: PIXI.Sprite;
    private _kamikazeText: PIXI.Sprite;
    private _bonusMeterContainer: PIXI.Container;
    private _bullets: PIXI.Sprite;

    public reset(): void {
        this._dogFightCovers.forEach((sprite:PIXI.Sprite)=>{
            sprite.visible =true;
        });

        this._bombAttackCovers.forEach((sprite:PIXI.Sprite)=>{
            sprite.visible =true;
        });
    }

    private init(): void {
        this._bonusMeterContainer = new PIXI.Container();
        this._bonusMeterContainer.scale.set(0.8);
        this._bonusMeterContainer.position.set(215, -334);
        this.addChild(this._bonusMeterContainer);

        this._bonusMeters = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("bonusMeters")[0]);
        this._bonusMeters.name = "bonusMeters";
        this._bonusMeters.position.set(0, 0);

        this._bullets = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("allBullets")[0]);
        this._bullets.name = "bullets";
        this._bullets.position.set(5, 48);

        this._spinsLeftCover = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("bonusMetersSpinsLeft")[0]);
        this._spinsLeftCover.name = "spinsLeftCover";
        this._spinsLeftCover.position.set(173, 61);
        this._spinsLeftCover.anchor.set(0, 0);

        this._bulletLeftCover = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("bonusMetersCover")[0]);
        this._bombLeftCover = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("bonusMetersCover")[0]);
        this._bombLeftCover.name = "bulletLeftCover";
        this._bulletLeftCover.position.set(42, 112);
        this._bulletLeftCover.anchor.set(0, 1);
        this._bombLeftCover.name = "bombLeftCover";
        this._bombLeftCover.position.set(384, 115);
        this._bombLeftCover.anchor.set(1, 1);

        const kamikazeContainer = new PIXI.Sprite();
        kamikazeContainer.name = "kamikazeContainer";
        kamikazeContainer.position.set(373, 308);
        kamikazeContainer.anchor.set(0.5, 0);

        const kamikazeTop = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("kamikazeTop")[0]);
        kamikazeTop.name = "kamikazeTop";
        kamikazeTop.position.set(0, 0);
        kamikazeTop.anchor.set(0.5, 0);

        this._kamikazeText = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("kamikazeText")[0]);
        this._kamikazeText.name = "kamikazeText";
        this._kamikazeText.position.set(10, 26);
        this._kamikazeText.anchor.set(0.5, 0);


        this._kamikazeCover = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("kamikazeMeter")[0]);
        this._kamikazeCover.name = "kamikazeCover";
        this._kamikazeCover.position.set(-116, 18);
        this._kamikazeCover.anchor.set(0, 0);
        this._kamikazeCover.width = 254;

        kamikazeContainer.addChild(this._kamikazeCover, kamikazeTop, this._kamikazeText)
        this._dogFightCovers = ArrayHelper.initArrayWithValues(3, (i: number) => {
            const cover: Sprite = this.createMeterCover(i, -(Math.PI * i * 2) / 3, "columnHitCover");
            cover.position.set(this.MG_COVER_POS[i][0],this.MG_COVER_POS[i][1]);
            cover.visible = true;
            return cover;
        });
        this._bombAttackCovers = ArrayHelper.initArrayWithValues(6, (j: number) => {
            const bombMeterCover: Sprite = this.createMeterCover(j, -Math.PI * j / 3, "rowCounterCower");
            bombMeterCover.position.set(this.BA_COVER_POS[j][0],this.BA_COVER_POS[j][1]);
            bombMeterCover.visible = true;
            return bombMeterCover;
        });

        this._baMeterBroken = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("dogFightPart")[0]);
        this._baMeterBroken.name = "dogFightPart";
        this._baMeterBroken.position.set(409, 2);
        this._baMeterBroken.anchor.set(1, 0);
        this._bonusMeters.addChild(this._spinsLeftCover, this._baMeterBroken);
        this._bonusMeterContainer.addChild(this._bullets, this._bulletLeftCover, this._bombLeftCover, this._bonusMeters);
        this.addChild(kamikazeContainer);
    }

    private createMeterCover(id: number, rotation: number, textureName: string): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures(textureName)[0]);
        sprite.name = textureName + id.toString();
        sprite.anchor.set(0.5, 1);
        sprite.rotation = rotation;
        this._bonusMeters.addChild(sprite);
        return sprite;
    }

    constructor() {
        super();
        this.name = "BonusMeters";
        this.init();
    }

    private countTrue(arr: boolean[]) {
        return arr.filter(w => w === true).length;
    }

    public updateBAMeter(max:number): void {
        this._bombAttackCovers.forEach((sprite:PIXI.Sprite,i:number)=>{
                sprite.visible = max<=i;
        });
    }
    public updateMGMeter(max:number): void{
        this._dogFightCovers.forEach((sprite:PIXI.Sprite, i:number)=>{
            sprite.visible = max<=i;
        });
    }
    public updateMGProgress(reduceOneBullet:boolean=false): TweenLite {
        let mgLeft: number = this.countTrue(PearlHarbor.model.dogfight.filledColumns),
            toWidth:number = 115 - (6-mgLeft) * 19,
        currentCoverWidth:number = this._bulletLeftCover.width;

        if(reduceOneBullet && (currentCoverWidth+18)<= toWidth){
            currentCoverWidth +=18;
        }else {
            currentCoverWidth = toWidth;
        }
        return TweenLite.to(this._bulletLeftCover, {duration:0.3, width:currentCoverWidth});
    }

    public updateBAProgress(reduceOneBomb:boolean=false): TweenLite {
        let baLeft: number = this.countTrue((<IFinalWave>PearlHarbor.model.dogfight).filledRows),
            toWidth:number = 115 - (3-baLeft) * 38,
        currentCoverWidth:number = this._bombLeftCover.width;
        if(reduceOneBomb && (currentCoverWidth+38)<=toWidth){
            currentCoverWidth +=38;
        }else{
            currentCoverWidth = toWidth;
        }
        return TweenLite.to(this._bombLeftCover, {duration:0.3, width: currentCoverWidth});
    }

    public updateFSLeft(id: number): TweenLite {
        if (id === 3) {
            this._spinsLeftCover.alpha = 0;
            return TweenLite.to(this._spinsLeftCover, 0.2, {alpha: 0});
        }
        this._spinsLeftCover.alpha = 1;
        return TweenLite.to(this._spinsLeftCover, 0.2, {height: (3-id) * 52});
    }

    public updateKamikazeMeter(stoppedNum: number): void {
        PearlHarbor.backgroundElements.updateCocpitIntensity(MathHelper.roundToDecimals(stoppedNum/18, 1));
        this._kamikazeCover.width = 2 + stoppedNum * 14;
        this._kamikazeText.alpha = stoppedNum * 0.6;
    }

    public updateMode(isFS: boolean, isRestore:boolean): void {
        this._baMeterBroken.visible = isFS;
        this.updateKamikazeMeter(isRestore?(18-PearlHarbor.model.dogfight.openPositions.length):0);
        this.updateMGProgress();
        this.updateFSLeft(PearlHarbor.model.dogfight.spinsLeft-(isRestore?1:0));
        if(!isFS){
            this.updateBAProgress();
        }
    }
}